<nz-modal
  nzWrapClassName="form-modal"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  [nzWidth]="'65%'"
  [nzClosable]="true"
  (nzOnCancel)="onEmitCloseModal(false)"></nz-modal>


<ng-template #modalTitle>
  <div class="container-steps-modal" @fadeInAnimation>
    <h2 class="text-title-md-bold title-modal" *ngIf="!completeData">{{ patient?._id ? 'Actualizar paciente' : 'Nuevo paciente' }}</h2>
    <h2 class="text-title-md-bold title-modal" *ngIf="completeData">¡Bienvenido! {{ patient?.user?.name + ' ' + patient?.user?.lastname }}</h2>
    <p class="text-info mt-xxs" *ngIf="!completeData">{{ patient._id ? 'Se actualizará el paciente' : 'Se agregará un nuevo usuario paciente a la clínica' }}</p>
    <p class="text-info mt-xxs" *ngIf="completeData">Por favor completa tu perfil para continuar.</p>



  </div>
</ng-template>


<ng-template #modalContent>
  <div *ngIf="true" class="container-modal" @fadeInAnimation>

    <div class="title-section-form" *ngIf="!completeData && !onlyRegister">
      <p class="title text-subtitle-bold-upper">¿CÓMO AGREGAR AL PACIENTE?</p>
      <div class="cards-container">
        <app-card-icon-text *ngFor="let type of registerTypes; index as i"
          class="cursor-pointer type-register-{{i}}"
          (click)="onChangeRegisterType(type)" [value]="type" [active]="registerTypeSelected === type.id"></app-card-icon-text>
      </div>
    </div>

    <div *ngIf="registerTypeSelected === 'invitation'" @fadeInAnimation>
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
        <div class="input-label-form">Correo electrónico</div>
        <input [required]="true" [formControl]="emailControl" name="emailCheck" nz-input type="text" class="input-email"
          (ngModelChange)="helperValidationField.onValidateEmailReactive(emailControl.value, emailControl)" />
        <div *ngIf="emailControl && emailControl.invalid && emailControl.dirty">
          <p nz-typography [nzType]="'danger'" style="font-size: 0.7em;" *ngIf="emailControl.getError('required')">Campo requerido</p>
          <p nz-typography [nzType]="'danger'" style="font-size: 0.7em;" *ngIf="!emailControl.getError('required') &&
            emailControl.getError('invalidEmail')">Correo electrónico inválido</p>
        </div>
        <p class="text-info mt-xs" *ngIf="!completeData && !userExists && !this.checkEmail">
          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
          El usuario no existe en la plataforma, puedes <span class="text-link" (click)="onInvite()">mandarle una invitación</span> para
          registrarse.
        </p>
        <p class="text-info mt-xs" *ngIf="!completeData && userExists">
          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
          El usuario existe en la plataforma, puedes mandarle una invitación para iniciar sesión.
        </p>
      </div>
    </div>

    <div nz-row *ngIf="registerTypeSelected === 'register' || completeData" @fadeInAnimation>
      <div nz-col class="mb-md text-subtitle-bold-upper">
        <p>Información básica</p>
      </div>
    </div>

    <div class="tw-w-full basic-form-register">
      <form #userForm="ngForm" *ngIf="patient?.user && ((registerTypeSelected === 'register' || completeData) || onlyRegister)" @fadeInAnimation>
        <div nz-row [nzGutter]="[15, 15]">
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24">
            <div class="input-label-form">Correo electrónico</div>
            <input [required]="true" [formControl]="emailControl" name="emailCheck" nz-input type="text"
              (ngModelChange)="helperValidationField.onValidateEmailReactive(emailControl.value, emailControl)" />
            <div *ngIf="emailControl && emailControl.invalid && emailControl.dirty">
              <p nz-typography [nzType]="'danger'" style="font-size: 0.7em;" *ngIf="emailControl.getError('required')">Campo requerido</p>
              <p nz-typography [nzType]="'danger'" style="font-size: 0.7em;" *ngIf="!emailControl.getError('required') &&
                emailControl.getError('invalidEmail')">Correo electrónico inválido</p>
            </div>
            <p class="text-info mt-xs" *ngIf="!completeData && userExists">
              <i nz-icon nzType="info-circle" nzTheme="outline"></i>
              El usuario existe en la plataforma, puedes mandarle una invitación para iniciar sesión.
            </p>
          </div>
          <div *ngIf="!userExists" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8">
            <div class="input-label-form">Nombre(s)</div>
            <input [required]="true" [disabled]="!emailControl.valid" [(ngModel)]="patient.user.name" #name="ngModel" name="name" nz-input type="text"
              />
            <app-message-field [field]="name"></app-message-field>
          </div>
          <div *ngIf="!userExists" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8">
            <div class="input-label-form">Apellidos</div>
            <input [required]="true" [disabled]="!emailControl.valid" [(ngModel)]="patient.user.lastname" #lastname="ngModel" name="lastname" nz-input
              type="text" />
            <app-message-field [field]="lastname"></app-message-field>
          </div>
          <div *ngIf="!userExists" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8">
            <div class="input-label-form">Fecha de nacimiento</div>
            <nz-date-picker [required]="true" [nzDisabled]="!emailControl.valid" [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY" #ngDateOfBirth="ngModel"
              name="ngDateOfBirth"
              [nzPlaceHolder]="'Fecha de nacimiento'" [(ngModel)]="patient.user.birthday" [nzDisabledDate]="utilitiesServices.disabledDate"></nz-date-picker>
            <app-message-field [field]="ngDateOfBirth"></app-message-field>
          </div>
          <div *ngIf="!userExists" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8">
            <div class="input-label-form">Género</div>
            <nz-select
              [(ngModel)]="this.patient.user.gender"
              [required]="true"
              [nzDisabled]="!emailControl.valid"
              name="ngGender"
              #ngGender="ngModel">
              <nz-option [nzValue]="this.genderEnum.MALE" nzLabel="Masculino"></nz-option>
              <nz-option [nzValue]="this.genderEnum.FEMALE" nzLabel="Femenino"></nz-option>
            </nz-select>
            <app-message-field [field]="ngGender"></app-message-field>
          </div>
          <div *ngIf="!userExists" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8">
            <div class="input-label-form">Zona horaria</div>
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Zona horaria" [nzDisabled]="!emailControl.valid" [required]="true"
              [(ngModel)]="patient.user.timeZone" #ngCountry="ngModel" name="timeZone">
              <nz-option *ngFor="let timeZone of timeZones;" [nzLabel]="timeZone" [nzValue]="timeZone"></nz-option>
            </nz-select>
            <app-message-field [field]="ngCountry"></app-message-field>
          </div>
        </div>
      </form>

      <div class="tw-flex tw-justify-center tw-items-center mt-xlg" *ngIf="(registerTypeSelected === 'register' && !userExists) || onlyRegister"
        @fadeInAnimation>
        <button nz-button nzType="primary" nzGhost (click)="showAddressAndPhone= !showAddressAndPhone">
          <i nz-icon [nzType]="showAddressAndPhone ? 'down' : 'right'" nzTheme="outline"></i>
          {{ showAddressAndPhone ? 'OCULTAR' : 'MOSTRAR' }} CAMPOS DE DIRECCIÓN Y TELÉFONO
        </button>
      </div>

      <nz-divider nzPlain *ngIf="showAddressAndPhone" @fadeInAnimation></nz-divider>

      <div *ngIf="((!userExists && registerTypeSelected === 'register') || completeData || onlyRegister) && showAddressAndPhone" nz-row
        [nzGutter]="[30, 30]"
        class="mb-xxs" @fadeInAnimation>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="16">
          <app-address-section
            [required]="false"
            [disabled]="!emailControl.valid"
            [address]="patient.user.address"
            [removeClassCardContainerShadow]="true"></app-address-section>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="8">
            <app-phones
            [phones]="patient.user.phones"
            [removeClassCardContainerShadow]="true"></app-phones>
          <!--[disabled]="!emailControl.valid"-->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalFooter>
  <div *ngIf="true" class="container-footer-modal" @fadeInAnimation>
    <button
      *ngIf="!completeData"
      style="margin-right: 5px;"
      (click)="onEmitCloseModal(false)"
      nz-button nzType="cancel">
      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
      CANCELAR</button>
    <button
      class="btn-register"
      *ngIf="(!userExists && registerTypeSelected === 'register') || completeData || onlyRegister"
      (click)="onEmitCloseModal(true)"
      nz-button nzType="primary">
      <!-- {{ this.patient._id ? 'Actualizar paciente' : 'Crear paciente' }} -->
      <i nz-icon nzType="save" nzTheme="outline"></i>
      {{ completeData ? 'Guardar datos' : 'Crear paciente'}}
    </button>

    <button
      class="btn-invite"
      [disabled]="!emailControl.valid"
      *ngIf="!completeData && userExists || (!completeData && !userExists && registerTypeSelected === 'invitation')"
      (click)="onInvite()"
      nz-button nzType="primary">
      <i nz-icon nzType="mail" nzTheme="outline"></i>
      Invitar a la clínica
    </button>
  </div>
</ng-template>
